import { useOnboardingStepView } from "analytics/onboarding";
import {
  DcaBotsType,
  OnboardingDetailedStep,
  TradingMethodType,
} from "@shared/features/onboarding/types";
import React, { useContext, useEffect } from "react";
import GuidedBotChoice from "features/onboarding/guided/GuidedBotChoice";
import useQuery from "utils/hooks/useQuery";
import { useSelector } from "react-redux";
import { selectWorkspace } from "@shared/slices/common.slice";
import { WorkspaceType } from "@shared/types";
import MethodSettingsLayout from "features/onboarding/methodSettings/MethodSettingsLayout";
import DcaBotsSection from "features/onboarding/methodSettings/dcaBot/DcaBotsSection";
import { useCopyDcaBot } from "@shared/features/onboarding/hooks";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { OnboardingStep } from "analytics/events";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";

const CopyDcaBot = () => {
  const query = useQuery();
  const workspace = useSelector(selectWorkspace);
  const { changeStep } = useContext(OnboardingContext)!;
  // In the URL, so the back button returns to the walkthrough.
  const browseAll = query.get("browse") === "1";
  const { publicBots, isLoading } = useCopyDcaBot();
  const { analytics } = useContext(AnalyticsContext);
  const isWalkthrough =
    workspace === WorkspaceType.DEMO &&
    query.get("guided") === "1" &&
    !browseAll;

  useEffect(() => {
    if (isWalkthrough) return;
    analytics?.onboardingPublicBotsView({
      onboardingStep: OnboardingStep.METHOD_SETTINGS,
    });
  }, [analytics, isWalkthrough]);
  useOnboardingStepView(isWalkthrough ? undefined : "public_bots");

  const options = (
    <>
      <DcaBotsSection
        botType={DcaBotsType.TRENDING}
        bots={publicBots?.trending_score || []}
        isLoading={isLoading}
      />
      <DcaBotsSection
        botType={DcaBotsType.LONG_RUNNING}
        bots={publicBots?.long_running_score || []}
        isLoading={isLoading}
      />
      <DcaBotsSection
        botType={DcaBotsType.HIGH_VOLUME}
        bots={publicBots?.high_volume_score || []}
        isLoading={isLoading}
      />
    </>
  );

  if (isWalkthrough) {
    return (
      <GuidedBotChoice
        onBrowse={() =>
          changeStep(OnboardingDetailedStep.COPY_DCA_BOT, { browse: "1" })
        }
      />
    );
  }

  return (
    <MethodSettingsLayout
      tradingMethod={TradingMethodType.DCA_BOT}
      options={options}
    />
  );
};

export default CopyDcaBot;
